import { Feeder, StepForms } from '@/stores/slices/setup-fund-slice';

const US_CODE = 'US';

export const isUsCountryCode = (code: string | null | undefined): boolean =>
  (code ?? '').trim().toUpperCase() === US_CODE;

export const isUsExemptionCountry = (label: string | null | undefined): boolean => {
  const v = (label ?? '').trim().toUpperCase();
  return v === 'US' || v === 'USA' || v === 'UNITED STATES';
};

export const isFundUsApplicable = (stepForms: StepForms): boolean =>
  isUsCountryCode(stepForms.investmentDescription?.jurisdictionCountry);

export const isFeederUsApplicable = (feeder: Feeder): boolean =>
  isUsCountryCode(feeder.jurisdictionCountry);
